<template>
  <v-navigation-drawer class="mx-auto mr-6" width="220" color="primary lighten-4" permanent app>

    <v-list-item two-line>
      <v-list-item-avatar color="white">
        <v-img src="https://cdn.vuetifyjs.com/images/logos/v.png" height="34" contain />
      </v-list-item-avatar>

      <v-list-item-title class="title">
        MarketScout
      </v-list-item-title>
    </v-list-item>

    <v-select
        v-if="user?.canAccessClients.length > 1"
        :items="user.canAccessClients"
        v-model="user.clientID"
        v-on:change="onClientChanged"
        item-text="clientName"
        item-value="clientID"
        label="Select Client"
        outlined
        dense
      >
      </v-select>
    <v-chip v-else-if="user?.clientName" class="mx-2 mb-1" color="cyan" label>
      {{ user?.clientName }}
    </v-chip>
    <v-chip v-if="user?.username" class="mx-2 mb-3" color="cyan" label>{{ user?.username }}</v-chip>

    <v-divider class="mx-3 mb-3" />
    <v-list>
      <v-list-item v-for="item in items" :key="item.title" :to="{ path: item.path }">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import ApiClient from '../../services/api/apiClient';
import { UserService } from '../../services/api/user';

export default {
  created() {
    const userService = new UserService();
    userService.getUser().then((data) => {
      this.user = data;
    }).catch((error) => {
      console.log('Error getting user: ' + error);
    });
  },

  computed: {
    // Build the nav from the router's top-level routes, hiding any restricted to a different client.
    items() {
      return this.$router.options.routes
        .filter(route => route.topLevel)
        .filter(route => {
          const requiresClientID = route.meta && route.meta.requiresClientID;
          return requiresClientID == null || (this.user && this.user.clientID === requiresClientID);
        })
        .map(route => ({
          name: route.name,
          path: route.path,
          icon: route.icon,
          title: route.name
        }));
    }
  },

  data: () => ({
    dialog: false,
    drawer: null,
    user: null,
  }),

  methods: {
    onClientChanged() {
      ApiClient.setClientID(this.user.clientID);
      this.$router.go();
    }
  }
}

/*
  export default {
    data () {
      return {
        items: [
          { title: 'Dashboard', icon: 'mdi-view-dashboard' },
          { title: 'Photos', icon: 'mdi-image' },
          { title: 'About', icon: 'mdi-help-box' },
        ],
        right: null,
      }
    },
  }
  */
</script>